import { DeliveryDateService } from '~/services/delivery-date-2';
import { getEasternDate } from '~/utils/calendar-utils';

class ShippingAvailabilityMessage extends HTMLElement {
  constructor() {
    super();

    this.shippingAvailableMessage = this.querySelector('[data-availability="available"]');
    this.shippingUnavailableMessage = this.querySelector('[data-availability="unavailable"]');
    this.genericShippingThresholdHours = parseInt(window.Boarderie.nextDeliveryDateDisplayHours, 10) || 48;
    this.deliveryDateService = new DeliveryDateService(window.Boarderie);
    this.dateFormat = this.getAttribute('format') || 'week-day';
  }

  connectedCallback() {
    this.render();
  }

  render() {
    if (!this.deliveryDateService || !this.deliveryDateService.deliveryDateISO) {
      this.showUnavailableMessage();
      return;
    }

    try {
      const arrivalDate = new Date(this.deliveryDateService.deliveryDateISO);
      const currentDate = getEasternDate().date;

      const timeDifferenceMs = arrivalDate.getTime() - currentDate.getTime();
      const timeDifferenceHours = timeDifferenceMs / (1000 * 60 * 60);

      if (timeDifferenceHours > this.genericShippingThresholdHours) {
        this.showUnavailableMessage();
      } else {
        this.showAvailableMessage();
      }
    } catch (error) {
      console.error('Error calculating delivery time:', error);
      this.showUnavailableMessage();
    }
  }

  showUnavailableMessage() {
    if (this.shippingAvailableMessage) {
      this.shippingAvailableMessage.setAttribute('hidden', 'true');
    }

    if (this.shippingUnavailableMessage) {
      this.shippingUnavailableMessage.removeAttribute('hidden');
    }
  }

  showAvailableMessage() {
    if (this.shippingAvailableMessage) {
      // Update Delivery Date
      const deliveryDateElements = this.querySelectorAll('[data-delivery-date]');
      if (deliveryDateElements.length) {
        const formattedDeliveryDate = this.deliveryDateService.getFormattedDeliveryDate(this.dateFormat);
        deliveryDateElements.forEach(element => {
          element.innerHTML = formattedDeliveryDate;
        })
      }

      // Update Free Delivery Date
      const formattedFreeDeliveryDate = this.deliveryDateService.getFormattedDeliveryDate(this.dateFormat, true);
      const freeDeliveryDateElements = this.querySelectorAll('[data-free-delivery-date]');
      if (freeDeliveryDateElements.length) {
        freeDeliveryDateElements.forEach(element => {
          element.innerHTML = formattedFreeDeliveryDate;
        })
      }

      // Surcharge price
      const surchargeProductPriceElements = this.querySelectorAll("[data-surcharge-price]")
      if (surchargeProductPriceElements.length) {
        const nextPremiumDate = this.deliveryDateService.deliveryDate
        const nextPremiumDateFee = this.deliveryDateService.getFees(nextPremiumDate, "dessert-board")
        const feeCost = nextPremiumDateFee[0]?.cost || 0
        const nextPremiumDatePrice = Shopify.formatMoney(feeCost * 100, "${{amount_no_decimals}}")

        surchargeProductPriceElements.forEach(element => {
          element.innerHTML = nextPremiumDatePrice
        })
      }

      this.shippingAvailableMessage.removeAttribute('hidden');
    }

    if (this.shippingUnavailableMessage) {
      this.shippingUnavailableMessage.setAttribute('hidden', 'true');
    }
  }
}

customElements.define('shipping-availability-message', ShippingAvailabilityMessage);